<!-- <template>
  <div>
    <b-row class="text-center title-bar">
      <b-col cols="3">
        <img class="main-logo" src="../../assets/vicky.png" alt="main-logo"  />
      </b-col>
      <b-col cols="7">
        <b-dropdown
          size="lg"
          variant="link"
          toggle-class="text-decoration-none"
          :class="pageroute == 'call' ? 'fontIcon makeDisable' : 'fontIcon'"
          no-caret
        >
          <template v-slot:button-content>
            <span class="title-status"> {{ current_agent_state }} </span>
            <font-awesome-icon
              class="fontIcon"
              style="font-size: 14px;"
              icon="chevron-down"
            />
          </template>

          <b-dropdown-item
            v-for="state in agent_states"
            :key="state.type"
            @click="changeAgentState(state)"
            style="fontIcon:makeDisable"
          >
            {{ state.name }}
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col >
        <font-awesome-icon v-if="pageroute =='home' || pageroute=='profile'"
          @click="toggleProfile()"
          :class="
            pageroute == 'call'
              ? 'fontIcon settingsIcon makeDisable'
              : 'fontIcon settingsIcon'
          "
          icon="user"
          size="md"
          style="margin-left: 20px;"
        />
      </b-col>
    </b-row>
    <!-- <dialer v-if="pageroute=='home'"></dialer> -->
 <!-- </div>
</template> -->
<template>
  <div>
    <b-row class="text-center title-bar">
      
      <!-- Logo -->
      <b-col cols="3">
        <img class="main-logo" src="../../assets/vicky.png" alt="main-logo" />
      </b-col>

      <!-- Status -->
      <b-col cols="7">
        <b-dropdown
          size="lg"
          variant="link"
          toggle-class="text-decoration-none"
          :class="pageroute == 'call' ? 'fontIcon makeDisable' : 'fontIcon'"
          no-caret
        >
          <template v-slot:button-content>
            <span class="title-status">{{ current_agent_state }}</span>
            <font-awesome-icon
              class="fontIcon"
              style="font-size: 14px;"
              icon="chevron-down"
            />
          </template>

          <b-dropdown-item
            v-for="state in agent_states"
            :key="state.type"
            @click="changeAgentState(state)"
          >
            {{ state.name }}
          </b-dropdown-item>
        </b-dropdown>
      </b-col>

      <!-- Profile Icon -->
      <b-col cols="2" class="icon-col">
        <font-awesome-icon
          v-if="pageroute =='home' || pageroute=='profile'"
          @click="toggleProfile()"
          :class="
            pageroute == 'call'
              ? 'fontIcon settingsIcon makeDisable'
              : 'fontIcon settingsIcon'
          "
          icon="user"
          size="md"
        />
      </b-col>

    </b-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import "amazon-connect-streams";
import "amazon-connect-chatjs";
// import Dialer from '../Dialer'

export default {
  name: "Navbar",
  data() {
    return {};
  },
  components: {
    // Dialer
  },
  methods: {
    changeAgentState(agentState) {
      let agent = new connect.Agent();
      agent.setState(agentState);
    },
    toggleProfile() {
      this.$store.dispatch(
        "common/routePage",
        this.pageroute == "home" ? "profile" : "home"
      );
    },
    // windowMethod(){
    //   console.log("WINDOW METHOD TRIGGERED")
    //   window.open("https://sandeza-inc-632154267669228137.myfreshworks.com/crm/messaging/a/795700952333984/inbox/0/0/conversation/797854965010274")
    // }
  },
  computed: {
    ...mapGetters([
      "agent_states",
      "current_agent_state",
      "pageroute",
      "homeSubNav",
    ]),
  },
};
</script>

<style scoped>
.makeDisable {
  pointer-events: none !important;
  cursor: not-allowed !important;
}

.title-bar {
  background-color: #12344d;
  margin: 0px !important;
  color: #fff;
  height: 48px;
  align-items: center;
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #264966;
}

.main-logo {
  width: 113px;
  height: 29px;
  margin-top: 10px;
  /* padding-left: 0; */
}

.title-status {
  color: #ffffff;
  font-size: 19px;
  font-weight: 200;
}

.fontIcon {
  color: #fff;
  cursor: pointer;
}
.title-bar {
  background-color: #12344d;
  margin: 0px !important;
  color: #fff;
  height: 48px;
  border-bottom: 1px solid #264966;
}

/* 🔥 KEY FIX: vertical alignment */
.title-bar > .col {
  display: flex;
  align-items: center;
}

/* Logo fix */
.main-logo {
  width: 113px;
  height: 29px;
  margin-top: 0; /* ❌ remove the old 10px */
}

/* Right icon alignment */
.icon-col {
  justify-content: flex-end;
}

.title-status {
  color: #ffffff;
  font-size: 19px;
  font-weight: 200;
}

.fontIcon {
  color: #fff;
  cursor: pointer;
}
</style>
